import "./product-management.scss";
import { useSearchParams } from "react-router-dom";
import { Select } from "common/InputForm";

import ProductComponent from "./ProductComponent/ProductComponent";
import ProductTypeComponent from "./ProductTypeComponent/ProductTypeComponent";

const ProductManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedTab = searchParams.get("Tab") || "product";

  return (
    <div className="product-management-container">
      <div className="page_title has_child">
        <h3>Product Management</h3>
          <div className="tabContainer">
          <ul>
            {[
              { id: 22, name: "Product", value: "product" },
              { id: 23, name: "Product Type", value: "productType" },
            ].map((tabMap) => (
              <li
                key={tabMap.id}
                className={
                  selectedTab === tabMap?.value ? "active" : "un-active"
                }
              >
                <button
                  type="button"
                  onClick={() => {
                    const urlInstance = new URLSearchParams(searchParams);
                    urlInstance.set("Tab", tabMap?.value);
                    setSearchParams(urlInstance);
                  }}
                >
                  {tabMap?.name}
                </button>
              </li>
            ))}
          </ul>
          {/* --------add product */}
          {/* <div>
            <button type="button" className="button">
              Add Products
            </button>
          </div> */}
        </div>
      </div>
      <div className="card">
        {/* -----tab and add product section */}

      

        <div className="">
          {selectedTab === "product" ? (
            <ProductComponent />
          ) : (
            <ProductTypeComponent />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductManagement;
